export const DndItemTypes = {
  DIAL: "dial-card",
  GROUP: "group-card",
};
